import { render, staticRenderFns } from "./EditModulePageDlg.vue?vue&type=template&id=0c7bfd92&scoped=true&"
import script from "./EditModulePageDlg.vue?vue&type=script&lang=ts&"
export * from "./EditModulePageDlg.vue?vue&type=script&lang=ts&"
import style0 from "./EditModulePageDlg.vue?vue&type=style&index=0&id=0c7bfd92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7bfd92",
  null
  
)

export default component.exports